// extracted by mini-css-extract-plugin
export default {"container":"About_container__DKKrg","info":"About_info__DYCFe","about-img":"About_about-img__fEsrH","flex-blocker":"About_flex-blocker__Yptdu"};